var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagCloase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72073 7.27947C7.84281 7.40155 7.84281 7.59948 7.72073 7.72157C7.6599 7.7824 7.5799 7.81322 7.4999 7.81322C7.4199 7.81322 7.3399 7.78282 7.27906 7.72157L4.9999 5.44239L2.72073 7.72157C2.65989 7.7824 2.5799 7.81322 2.4999 7.81322C2.4199 7.81322 2.3399 7.78282 2.27906 7.72157C2.15698 7.59948 2.15698 7.40155 2.27906 7.27947L4.55823 5.00031L2.27906 2.72116C2.15698 2.59908 2.15698 2.40115 2.27906 2.27906C2.40115 2.15698 2.59906 2.15698 2.72115 2.27906L5.00031 4.55824L7.27948 2.27906C7.40156 2.15698 7.59948 2.15698 7.72156 2.27906C7.84364 2.40115 7.84364 2.59908 7.72156 2.72116L5.44239 5.00031L7.72073 7.27947Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagCloase);
export default __webpack_public_path__ + "static/media/tagCloase.32a8f298b3cc447798bcb11fe89cdb24.svg";
export { ForwardRef as ReactComponent };